(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-id/assets/javascripts/coupon-id-provider.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-id/assets/javascripts/coupon-id-provider.js');
"use strict";

const _svs$components$tipse = svs.components.tipsen.couponId,
  CouponIdContext = _svs$components$tipse.CouponIdContext,
  useCouponQueryParams = _svs$components$tipse.useCouponQueryParams,
  PaymentContext = _svs$components$tipse.PaymentContext,
  useTrackingEvents = _svs$components$tipse.useTrackingEvents,
  usePlaceBet = _svs$components$tipse.usePlaceBet,
  useCartCallback = _svs$components$tipse.useCartCallback;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const _React = React,
  useMemo = _React.useMemo;
const TRANSFERRING_QUERY_PARAM = 'transfer';
const CouponIdProvider = _ref => {
  let type = _ref.type,
    children = _ref.children;
  const draw = useCurrentDraw();
  const couponId = "".concat(draw.productId, "_").concat(draw.drawNumber, "_").concat(type);
  useTrackingEvents(couponId);
  useCouponQueryParams(couponId);
  const couponIdContext = useMemo(() => ({
    couponId,
    type
  }), [couponId, type]);
  const placeBet = usePlaceBet(couponId, draw);
  useCartCallback(couponId);
  return React.createElement(CouponIdContext.Provider, {
    value: couponIdContext
  }, React.createElement(PaymentContext.Provider, {
    value: placeBet
  }, children));
};
CouponIdProvider.TRANSFERRING_QUERY_PARAM = TRANSFERRING_QUERY_PARAM;
setGlobal('svs.components.tipsen.couponId.CouponIdProvider', CouponIdProvider);

 })(window);